window.addEventListener('load', function () {
    var _learnq = window._learnq || [];
    
    function getSectionsToRender() {
        return [
            {
                id: 'Cart',
                section: 'main-cart',
                selector: '.thb-cart-form'
            },
            {
                id: 'Cart-Drawer',
                section: 'cart-drawer',
                selector: '.cart-drawer'
            },
            {
                id: 'cart-drawer-toggle',
                section: 'cart-bubble',
                selector: '.thb-item-count'
            }
        ];
    }
    function handleResponse() {
        console.log("here json response section", JSON.parse(this.responseText));
      }
      
      const request = new XMLHttpRequest();
      
      request.addEventListener('load', handleResponse);
      request.open('GET', '/?sections=shopify-section-cart-drawer', true);
      request.send();

    function addedToCart() {
        fetch(`${window.location.origin}/cart?view=ajax`)
            .then(res => res.text())
            .then(data => {
                // Create a new object with added sections
                // const updatedData = {
                //     ...data,
                //     sections: getSectionsToRender().map(section => section.section)
                // };

                // convert data text to node 

                const parser = new DOMParser();
                const html = parser.parseFromString(data, 'text/html');

                document.body.classList.add('open-cc');
                document.body.classList.add('open-cart');
                document.querySelector('html').classList.add('open-cart');

                document.getElementById('Cart-Drawer').classList.add('active');
            
                renderContents(html); 
                function getSectionInnerHTML(html, selector = '.shopify-section') {
                    return new DOMParser()
                      .parseFromString(html, 'text/html')
                      .querySelector(selector).innerHTML;
                  }
                function renderContents (parsedState) {
                    getSectionsToRender().forEach((section => {
                      if (!document.getElementById(section.id)) {
                        return;
                      }
                      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                 
                      elementToReplace.innerHTML = parsedState.querySelector(section.selector).innerHTML;
              
                    //   if (typeof CartDrawer !== 'undefined') {
                    //     new CartDrawer();
                    //   }
                    //   if (typeof Cart !== 'undefined') {
                    //     new Cart().renderContents(parsedState);
                    //   }
                    }));
              
                }

             
                // 
                let cart = {
                    total_price: updatedData.total_price / 100,
                    $value: updatedData.total_price / 100,
                    total_discount: updatedData.total_discount,
                    original_total_price: updatedData.original_total_price / 100,
                    items: updatedData.items
                };

                if (item !== 'undefined') {
                    cart = Object.assign(cart, item);
                }

                if (klAjax) {
                    _learnq.push(['track', 'Added to Cart', cart]);
                    klAjax = false;
                }
            })
            .catch(error => console.error('Error fetching cart data:', error));
    }
    
    // (function (ns, fetch) {
    //     ns.fetch = function () {
    //         const response = fetch.apply(this, arguments);
    //         response.then(res => {
    //             if (
    //                 `${window.location.origin}/cart/add.js`.includes(res.url) &&
    //                 res.url !== ''
    //             ) {
    //                 console.log("Added to cart", res);
    //                 addedToCart();
    //             }
    //         });
    //         return response;
    //     };
    // }(window, window.fetch));
    
    var klAjax = true;
    var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
    for (var i = 0; i < atcButtons.length; i++) {
        atcButtons[i].addEventListener("click", function () {
            if (klAjax) {
                _learnq.push(['track', 'Added to Cart', item]);
                klAjax = false;
            }
        });
    }
});
